import Logo from "@/components/ui/Logo"
import { useI18n } from "@/lib/i18n"

export default function ErrorFallback() {
  const { t } = useI18n()

  return (
    <div className="min-h-screen bg-surface flex flex-col items-center justify-center px-4">
      <Logo className="mb-10" />

      <div className="text-center max-w-sm">
        <h1 className="text-xl font-display font-bold text-slate-900 mb-2">
          {t("errors.fallback.title")}
        </h1>
        <p className="text-sm text-ink-muted mb-8">
          {t("errors.fallback.description")}
        </p>

        <button
          type="button"
          onClick={() => window.location.reload()}
          className="inline-block bg-brand-500 hover:bg-brand-600 text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-200"
        >
          {t("errors.fallback.reload")}
        </button>
      </div>
    </div>
  )
}
